export default __webpack_public_path__ + "static/media/affiliates.e40867a7.svg";